/**
 * Get LaunchDarkly user context from localStorage.
 * Only returns context when an Okta session exists (merchant flow).
 */
export const getLaunchDarklyUserContext = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    // Only initialise LD context for the merchant flow (Okta session present)
    const oktaTokenStorage = localStorage.getItem('okta-token-storage');
    if (!oktaTokenStorage) {
      return null;
    }

    const oktaData = JSON.parse(oktaTokenStorage);
    const userId = oktaData?.idToken?.claims?.preferred_username || null;

    if (!userId) {
      return null;
    }

    let merchantNames = [];
    const currentUser = localStorage.getItem('CURRENT_USER');
    if (currentUser) {
      const userData = JSON.parse(currentUser);
      if (userData?.profiles && Array.isArray(userData.profiles)) {
        merchantNames = userData.profiles
          .map((profile) => profile.merchantName)
          .filter(Boolean);
      }
    }

    return {
      key: userId,
      ...(merchantNames.length > 0 && {
        custom: { merchantNames },
      }),
    };
  } catch {
    return null;
  }
};
